import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import PointOfSaleRoundedIcon from '@mui/icons-material/PointOfSaleRounded';
import Button from '@mui/material/Button/Button';
import CircularProgress from '@mui/material/CircularProgress/CircularProgress';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack/Stack';

import PageTitle from '@/shared/components/layouts/PageTitle';
import Customer from '@/shared/types/customer.type';

type TitleProps = {
  isLoading: boolean;
  productsInCartLength: number;
  currency: string;
  assignedCustomer: Customer | null;
  onCheckout: () => void;
  onClearCart: () => void;
  onClickAssignedCustomer?: () => void;
  onCurrencyChange: (currency: string) => void;
};

const Title: FC<TitleProps> = ({
  isLoading,
  productsInCartLength,
  currency,
  assignedCustomer,
  onCheckout,
  onClearCart,
  onClickAssignedCustomer,
  onCurrencyChange,
}) => {
  const { t } = useTranslation(['checkout', 'common']);

  return (
    <PageTitle
      title={t('common:checkout')}
      breadcrumbs={[
        {
          label: t('common:checkout'),
          icon: (
            <PointOfSaleRoundedIcon
              sx={{ width: 16, height: 16, color: 'text.secondary' }}
            />
          ),
        },
      ]}
      actions={
        <Stack direction='row' spacing={2}>
          <Select
            value={currency}
            onChange={(e) => onCurrencyChange(e.target.value)}
          >
            <MenuItem value='CAD'>CAD</MenuItem>
            <MenuItem value='USD'>USD</MenuItem>
          </Select>

          <Button variant='outlined' onClick={onClearCart} color='inherit'>
            {t('checkout:clearCart')}
          </Button>

          <Button
            variant='contained'
            startIcon={
              isLoading ? <CircularProgress color='inherit' size={16} /> : null
            }
            disabled={
              productsInCartLength === 0 || !assignedCustomer?.display_full_name
            }
            onClick={() => {
              if (isLoading) return;
              onCheckout();
            }}
          >
            {t('common:checkout')}
          </Button>
        </Stack>
      }
      // actions={[
      //   {
      //     label: t('checkout:clearCart'),
      //     icon: null,
      //     button: {
      //       size: 'large',
      //       variant: 'outlined',
      //       color: 'inherit',
      //       onClick: () => {
      //         void onClearCart();
      //       },
      //       sx: { gap: 1 },
      //     },
      //   },
      //   {
      //     label: t('common:checkout'),
      //     icon: isLoading && <CircularProgress color='inherit' size={16} />,
      //     button: {
      //       size: 'large',
      //       variant: 'contained',
      //       disabled:
      //         productsInCartLength === 0 ||
      //         !assignedCustomer?.display_full_name,
      //       onClick: () => {
      //         if (isLoading) return;

      //         void onCheckout();
      //       },
      //       sx: { gap: 1 },
      //     },
      //   },
      // ]}
      customColumn={
        assignedCustomer && (
          <Stack>
            <Button
              size='large'
              variant='text'
              color='inherit'
              disabled={!assignedCustomer?.display_full_name}
              sx={{
                textTransform: 'uppercase',
                borderBottom: 1,
                borderRadius: '8px 8px  0 0',
              }}
              onClick={onClickAssignedCustomer}
            >
              {assignedCustomer?.display_full_name}
            </Button>
          </Stack>
        )
      }
    />
  );
};

export default Title;
